export default {
  guest: {
    earn_pts: 'Ansaitse {{points}} pistettä tästä tilauksesta',
    tagline: 'Palkitaan joka tilauksesta, joka kerta.',
    pick_reward: 'Valitse haluamasi palkinto, kun pääset perille',
    free_at: 'ilmainen {{points}} pisteellä',
    save_at: 'säästä {{amount}} {{points}} pisteellä',
    nearest: 'lähin',
    cta: 'Aloita ansaitseminen — se on ilmaista',
    already_member: 'Oletko jo jäsen?',
    sign_in: 'Kirjaudu sisään',
  },
  member: {
    earning_free: 'Ansaitset ilmaista ruokaa',
    every_euro_one: 'Jokainen kuluttamasi {{amount}} = 1 piste. Vaihda ilmaisiin tuotteisiin ja alennuksiin.',
    every_euro_other:
      'Jokainen kuluttamasi {{amount}} = {{count}} pistettä. Vaihda ilmaisiin tuotteisiin ja alennuksiin.',
    until_redeem: '{{remaining}} pistettä, ennen kuin voit alkaa lunastaa',
    unlock_first: 'Jo tämä tilaus avaa ensimmäisen palkintosi!',
    so_close: 'Niin lähellä ilmaista ruokaa!',
    just_more: 'Vain {{remaining}} pistettä lisää, niin voit alkaa säästää.',
    pts_to_unlock: '{{remaining}} pistettä palkintojen avaamiseen',
    this_order_unlocks: 'Tämä tilaus vie sinut {{points}} pisteeseen — voit lunastaa seuraavalla tilauksella!',
    save_next: 'Säästä jopa {{amount}} ensi kerralla',
    pts_from_order: '+{{earned}} pistettä tästä tilauksesta — enää {{remaining}} jäljellä!',
    rewards_value: '= {{amount}} palkintoina',
    save_this_order: 'Säästä jopa {{amount}} tästä tilauksesta',
    use_pts: 'Käytä {{points}} pistettäsi kassalla',
    earned_this_order: '+{{points}} pistettä ansaittu tästä tilauksesta',
    current: 'Nykyinen',
    from_this_order: '+{{points}} tästä tilauksesta',
    expiration_zero: '{{points}} pistettä vanhenee tänään',
    expiration_one: '{{points}} pistettä vanhenee 1 päivässä',
    expiration_other: '{{points}} pistettä vanhenee {{count}} päivässä',
  },
};
